import React from 'react';
import { Grid } from '@mui/material';
import DevicesPanel from '../Panels/DevicesPanel';
import AlarmPanel from '../Panels/AlarmPanel';
import MapPanel from '../Panels/MapPanel';

function DashboardPage() {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={6}>
        <DevicesPanel />
      </Grid>
      <Grid item xs={12} md={6}>
        <AlarmPanel />
      </Grid>
      <Grid item xs={12} md={12}>
        <MapPanel />
      </Grid>
    </Grid>
  );
}

export default DashboardPage;
